/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Filter_Zoom_ClearInputs */

const en_ui_filter_zoom_clear = /** @type {(inputs: Ui_Filter_Zoom_ClearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove filter: ${i?.name}`)
};

const de_ui_filter_zoom_clear = /** @type {(inputs: Ui_Filter_Zoom_ClearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filter entfernen: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Remove filter: {name}" |
*
* @param {Ui_Filter_Zoom_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_zoom_clear = /** @type {((inputs: Ui_Filter_Zoom_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Zoom_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_zoom_clear(inputs)
	return de_ui_filter_zoom_clear(inputs)
});